(function() {


    var validation;
    var isLogin = lgkorUI.isLogin;
    
    // BTOCSITE-72831 고객의 소리- 사이트 관련 문의 - LG전자 회원 본인인증 절차 추가 요청
    var authManager;
    var authFlag = lgkorUI.isLogin;
    

    var orderTmpl = 
	'{{#if items.length > 0}}' +
	'{{#each (item, index) in items}}' +
		'<dt class="order-info">' +
	        '<span class="rdo-wrap">'+
		        '<input type="radio" id="rdo_prod_{{#raw item.increment_id}}" name="rdo_prod" value="{{item.increment_id}}">'+
		        '<label for="rdo_prod_{{#raw item.increment_id}}">'+
				    '<span class="date"><em>{{item.order_date}}</em></span>' +
				    '<span class="number"><em>{{item.increment_id}}</em></span>' +
		        '</label>'+
		    '</span>'+

		'</dt>' +
		'<dd>' +
		    '<ul class="order-list">' +
		   		'{{#if item.items.length > 0}}'+
		   		'{{#each (itm, idx) in item.items}}'+
		   		
                '<li>'+
	                '<div class="box">'+
	                    '<p class="prod-thumb">'+
	                        '<img src="{{itm.image_url}}" alt="{{itm.product_sku}}">'+
	                    '</p>'+
	
	                    '<p class="prod-info">'+
	                        '<span class="state">'+

	                        	'<em>{{itm.product_option.item_status}}</em>'+
	                        '</span>'+
	                        '<span class="title">'+
	                            '{{itm.product_name}}'+
	                        '</span>'+
	                        '<span class="code">{{itm.product_sku}}</span>'+
	                        '<span class="price">{{itm.product_sale_price.value}}원</span>'+
	                    '</p>'+
	                '</div>'+
	            '</li>'+
		        
		        '{{/each}}'+
		        '{{/if}}'+
		    '</ul>' +
		'</dd>' +
	 '{{/each}}' +
	 '{{/if}}';
	 
    
    var reservation = {
        init: function() {
            var self = this;

            self.$cont = $('.contents');
            self.$searchModelWrap = self.$cont.find('.prod-search-wrap');
            self.$selectedModelBar = self.$cont.find('.prod-selected-wrap');
            self.$myModelWrap = self.$cont.find('.my-product-wrap');
            self.$submitForm = self.$cont.find('#submitForm');
            self.$completeBtns = self.$cont.find('.btn-group');
            
            self.$step1 = self.$cont.find('#step1');
            self.$stepInquiry = self.$cont.find('#stepInquiryType');
            self.$stepInput = self.$cont.find('#stepInput');
            self.$stepInput2 = self.$cont.find('#stepInput2'); // mobile에선 분리 영역이라 나눔

            self.$textarea = self.$stepInput.find('textarea');
            self.$completeBottomBtns1 = self.$stepInput.find('.btn-bottom');
            self.$completeBottomBtns2 = self.$stepInput2.find('.btn-bottom');
            $('#stepInputBtn1').prop('disabled', true);
            $('#stepInputBtn2').prop('disabled', true);  
            
            self.$inquiryListWrap = self.$cont.find('#inquiryList');
            self.$inquiryList = self.$inquiryListWrap.find('.rdo-list');
            
            //이메일
            self.$userEmailWrap = $('.email-wrap');
            self.$email = $('#userEmail');
            self.$userEmailId = $('#userEmailId');
            
            //주문조회 팝업
            self.$orderSearchPopup = $('#orderSearchPopup');
            self.$termFilter = self.$orderSearchPopup.find('.term-filter');    
            
            if(!lgkorUI.isLogin)  $('.login-guide').show();

            self.param = {};
            self.resultUrl = self.$searchModelWrap.data('resultUrl');
            
            
            //BTOCSITE-64468 고객지원 > 1:1 문의시 주문번호 및 상품번호 조회 기능 제공
            self.$searchWrap = self.$stepInput.find('.ui_search_model');
            self.$searchInput = self.$stepInput.find('.ui_search_model .ui_input_clearbutton ');
            self.$autocompleteWrap = self.$stepInput.find('.ui_search_model .autocomplete-box');
            self.$keywordList = self.$stepInput.find('.ui_search_model .search-layer .keyword-list');
            

            // BTOCSITE-72831 고객의 소리- 사이트 관련 문의 - LG전자 회원 본인인증 절차 추가 요청
            self.$authPopup = $('#certificationPopup');
            
            self.$searchWrap.search({
                template: {
                    autocompleteList: '<li><a href="#" data-model="{{model}}">{{model}}</a></li>',
                }
            });            
            
            self.$keywordList.on('click', 'a', function(e) {
            	e.preventDefault();				
				var val  = $(this).data('model');
				self.$searchInput.val(val);
				self.$searchWrap.find('.search-layer .btn-close').trigger('click');
            });
            
            self.$searchWrap.on('autocomplete', function(e, param, autocompleteUrl, callback) {
                lgkorUI.requestAjaxData(autocompleteUrl, param, function(result) {
                    callback(result);
                });
            });

            self.setUserEmail(); // BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
            self.replaceTitleText();
            var register = {
                privcyCheck: {
                    required: true,
                    msgTarget: '.err-block',
                    errorMsg: '개인정보 수집 및 이용에 동의 하셔야 이용 가능합니다.'
                },
                subsection: {
                    required: true,
                    msgTarget: '.type-msg',
                    errorMsg: '정확한 제품증상을 선택해주세요.'
                },
                cRcptNo: {
                    required: true,
                    msgTarget: '.err-block',
                    errorMsg: '접수 번호를 입력해주세요.'
                },
                inquiryTitle: {
                    required: true,
                    maxLength: 40,
                    msgTarget: '.err-block',
                    errorMsg: '제목을 입력해주세요.'
                },
                inquiryContent: {
                    required: true,
                    maxLength: 1000,
                    msgTarget: '.err-block',
                    errorMsg: '내용을 입력해주세요.'
                },
                userName: {
                    required: true,
                    maxLength: 30,
                    pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
                    msgTarget: '.err-block',
                    errorMsg: '이름을 입력해주세요.',
                    patternMsg: '이름은 한글 또는 영문으로만 입력해주세요.'
                },
                phoneNo: {
                    required: true,
                    minLength: 10,
                    maxLength: 11,
                    msgTarget: '.err-block',
                    errorMsg: '정확한 휴대폰 번호를 입력해주세요.',
                    patternMsg: '정확한 휴대폰 번호를 입력해주세요.',
                    validate : function(value){
                        return validatePhone(value);
                    }
                },
                userEmailId:{
                    required: true,
                    pattern: /^(?:[a-z\d][a-z\d._-]*|"[^"\r\n]+")@(?:\[\d{1,3}(?:\.\d{1,3}){3}\]|[a-z\d-]+\.[a-z]{2,})$/i,
                    minLength: 1,
                    maxLength: 50,
                    msgTarget: '.err-block',
                    errorMsg: '이메일 주소를 입력해주세요.',
                    patternMsg: '올바른 이메일 형식이 아닙니다.',
                    validate : function(value){
                        var _value = value;
                        var selectVal = $('#userEmailSelect select').val();

                        if (selectVal !== "direct") {
                            _value += "@" + selectVal;
                        }

                        var _pattern = new RegExp(this.pattern);

                        return _pattern.test(_value) && _value.split('@')[0].length <= 30 && _value.split('@')[1].length <= 20;
                        
                    }
                }  
            }
            // BTOCSITE-14892 동영상 첨부 기능 추가
            vcui.require(['ui/validation', 'ui/imageMovFileInput', 'support/common/searchModel.min', 'ui/datePeriodFilter'], function () {
                self.bindEvent();
                self.checkMypageInquiry(); // BTOCSITE-54775 [고객지원] 마이페이지> 배송문의 랜딩 url 확인
                
                validation = new vcui.ui.CsValidation('.step-area', {register:register});
                // BTOCSITE-14892 동영상 첨부 기능 추가
                // BTOCSITE-15196 동영상 파일 첨부 관련 아이폰 동영상
                self.$cont.find('.ui_imageinput').vcImageMovFileInput({regex: /[?!,&^~]/});
                self.$cont.vcSearchModel(); 

                var url = location.search;
                if (url.indexOf("?") > -1) {                    
                    var search = url.substring(1);
                    var searchObj = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

                    if (searchObj.parts) {
                        $('#stepInquiryType').find('[data-sub-category-name="케어용품/소모품"]').trigger('click');
                    } else if (searchObj.simple) {
                        $('#stepInquiryType').find('[data-sub-category-name="LG전자 회원"]').trigger('click');
                    }
                }

                // BTOCSITE-72831 고객의 소리- 사이트 관련 문의 - LG전자 회원 본인인증 절차 추가 요청
                var authOptions = {
                    elem: {
                        popup: '#certificationPopup',
                        name: '#authName',
                        phone: '#authPhoneNo',
                        number: '#authNo'
                    },
                    target: {
                        name: '#userName',
                        phone: '#phoneNo'
                    },
                    register: {
                        authName: {
                            required: true,
                            maxLength: 30,
                            pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
                            msgTarget: '.err-block',                        
                            errorMsg: '이름을 입력해주세요.',
                            patternMsg: '이름은 한글 또는 영문만 입력 가능합니다.'
                        },
                        authPhoneNo: {
                            required: true,
                            minLength: 10,
                            maxLength: 11,
                            msgTarget: '.err-block',
                            errorMsg: '정확한 휴대폰 번호를 입력해주세요.',
                            patternMsg: '정확한 휴대폰 번호를 입력해주세요.',
                            validate : function(value){
                                return validatePhone(value);
                            } 
                        },
                        authNo:{
                            required: true,
                            msgTarget: '.err-block',
                            errorMsg: '인증 번호를 입력해주세요.',
                        }
                    }
                }
                // BTOCSITE-72831 고객의 소리- 사이트 관련 문의 - LG전자 회원 본인인증 절차 추가 요청
                authManager = new AuthManager(authOptions);
            });
        },
        // BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
        setBSVal: function(id, val){ //bottomsheet
        	var targetId = $('a[linkid="' +id+'"]');
        	var targetBS = $("#" + id);
            var targetText =  targetId.find('.ui-select-text');
           	var defaultVal = targetId.find('span').attr("defaultVal");

        	if(!!val){
        		targetText.addClass("selected");
        		
        		targetBS.find('li').removeClass('on');
        		targetBS.find('li').each(function(item){                 		
             		var _this = $(this); 
             		var text = _this.find('a').data('text');
        			if(_this.find('a').data('value') == val){
             			_this.addClass('on');
             			targetText.html(text);
             		}
              	});
        	}else{
        		targetText.html(defaultVal);
        		targetText.removeClass("selected");
               	targetBS.find('li').removeClass('on');
        	}
        },
        // BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
        setUserEmail: function(){
        	var self = this;	
            var email = self.$email.val();
            if (!lgkorUI.isLogin || vcui.isEmpty(email)) {
                return;
            }
            
            var emailId = email.substr(0, email.indexOf("@",0));
            var emailDomain = email.substr(email.indexOf("@",0)+1);
            
            var domainArr = [];
            $("#emailSelect option").each(function(){
            	domainArr.push($(this).val());
            });
            
            if( vcui.array.include(domainArr, emailDomain) ){
            	self.$userEmailId.val(emailId);
            	$('#emailSelect').vcSelectbox('value', emailDomain);
            	self.setBSVal('bottomSheet-emailSelect', emailDomain); //bottomsheet
            	self.$userEmailWrap.removeClass('no-mark');
            }else{
                self.$userEmailId.val(email);
                $('#emailSelect').vcSelectbox('value', 'direct');
                self.setBSVal('bottomSheet-emailSelect', 'direct'); //bottomsheet
            }
        },
     	// BTOCSITE-47599 로그인 후, 정보 '선택해주세요' or '입력해주세요' 부분 문구 정비
        replaceTitleText: function(){
            if(!lgkorUI.isLogin) return;
            var self = this;
            var isUserNm = $('#userName').val() != '',
                isPhoneNo= $('#phoneNo').val() != '',
                isEmail = self.$email.val() != '';

            if(isUserNm && isPhoneNo && isEmail) {
                var title = $('.tit.re-text');
                var text = title.html();
                title.html(text.replace('입력해', '확인해'));
            }
        },
		checkMypageInquiry: function(){
			var self = this;
			var subCate =  lgkorUI.getParameterByName("subCategory");
		
			if( !vcui.isEmpty(subCate) ){
				var btn = self.$stepInquiry.find('.btn-type[data-sub-category="'+ vcui.string.toFirstUpper(subCate) +'"]');
				setTimeout(function(){
					btn.trigger('click');				
				}, 10)
			}
		},
        loadInquiry: function() {
            var self = this;
            var param = {
                category: self.param.category,
                subCategory: self.param.subCategory,
                modelCode: self.param.modelCode,
                serviceType: self.param.serviceType
            };

            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(self.resultUrl, param, function(result) {
                var data = result.data;
                var _result = data.inquiryList instanceof Array ? data.inquiryList.length : false;

                if(_result){
                    self.nextStepInput();
                }

                lgkorUI.hideLoading();
            });
        },
        nextStepInput: function() {
        	var self = this;
            var summaryOpt = {
                product: [self.param.categoryNm, self.param.subCategoryNm, self.param.modelCode],
                reset: 'type'
            };
            self.$selectedModelBar.show();
            self.$completeBtns.show();

            $('#step1').removeClass('active');
            $('#stepInquiryType').removeClass('active');

            //모바일 사이즈
            if( window.innerWidth < 768) {
            	$("#stepInput").addClass("active");
                $("#stepInput2").removeClass("active");
                
                $(".wrap").addClass("cs-service");
                lgkorUI.setBottomTabBarVisible(false);
            }
            //PC 사이즈
            if( window.innerWidth >= 768) {
                $("#stepInput").addClass("active");
                $("#stepInput2").addClass("active");
                window.scrollTo(0,0);
            }

            self.$cont.vcSearchModel('updateSummary', summaryOpt);
        },
        complete: function complete(data) {
            var self = this;
            self.param = $.extend(self.param, data || {});

            $('#category').val(self.param.category);
            $('#categoryNm').val(self.param.categoryNm);
            $('#subCategory').val(self.param.subCategory);
            $('#subCategoryNm').val(self.param.subCategoryNm);


            console.log('##  self.param ', self.param);

            setTimeout(function() {
                self.nextStepInput();
            }, 100);

        },
        // BTOCSITE-15196 동영상 파일 첨부 관련 아이폰 동영상
        renameFile: function(file) {
            // 1. 방어 코드: 파일 객체가 아니거나 name 속성이 없으면 원본 객체 그대로 반환
            if (!file || typeof file.name !== 'string') {
                return file; 
            }

            var lastDotIndex = file.name.lastIndexOf(".");
            var name = lastDotIndex !== -1 ? file.name.substring(0, lastDotIndex) : file.name;
            var ext = lastDotIndex !== -1 ? file.name.substring(lastDotIndex + 1) : '';
            
            // 2. 특수문자 제거 및 대체
            var regex = /[?!,.&^~]/g; // 전역(g) 매칭 추가
            if (regex.test(name)) {
                name = name.replace(regex, '_');
            }
            
            var newFileName = ext ? name + '.' + ext : name;

            // 3. FormData를 거치지 않고, 표준 File 생성자를 사용해 새 File 객체 반환
            return new File([file], newFileName, {
                type: file.type,
                lastModified: file.lastModified
            });
        },
        requestComplete: function() {
            var self = this;
            var url = self.$submitForm.data('ajax'),
                param = validation.getAllValues(),
                formData = new FormData;
            
            param.typeFlag = self.$submitForm.data('typeFlag');
            
            for (var key in param) {
                // BTOCSITE-15196 동영상 파일 첨부 관련 아이폰 동영상
                if (key.includes('imageFile') && param[key]) {
                    param[key] = self.renameFile(param[key]);
                }
                formData.append(key, param[key]);
            }

            lgkorUI.showLoading();
            lgkorUI.requestAjaxFileData(url, formData, function(result) {
                var data = result.data,
                    param = result.param;

                if (data.resultFlag == 'Y') {
                    for (var key in param) {
                        var $hidden = document.createElement("input");
                        $hidden.type = "hidden";
                        $hidden.name = key;
                        $hidden.value = param[key];
                        self.$submitForm.append($hidden);
                    }
                    self.$submitForm.submit();
                } else {
                    lgkorUI.hideLoading();
                    
                    if (data.resultMessage) {
                        lgkorUI.alert("", { title: data.resultMessage });
                    }
                }
            }, 'POST');
        },
     	//주문번호 조회
        orderSearchInit: function(){
        	var self = this;
        	if(!lgkorUI.isLogin){
                return;
            }
        	        	        
            self.$termFilter.vcDatePeriodFilter({"dateBetweenCheckValue":"3m"});
            
            var dateData = self.$termFilter.vcDatePeriodFilter("getSelectOption");                
            var startDate =vcui.date.format(dateData.startDate, "yyyy-MM-dd");
            var endDate = vcui.date.format(dateData.endDate, "yyyy-MM-dd");

        	var param = {
                    "pageSize": 10,
        			"currentPage": 1,
        			"filters_from": startDate,
        			"filters_to": endDate,
        	}

        	self.requestCustomerOrder(param);
        },
        //주문번호 조회
        requestCustomerOrder: function(param) {
        	var self = this;
        	var $orderList = self.$orderSearchPopup.find('.order-list-wrap');
        	var url = self.$orderSearchPopup.data('url');
        	var $morebtn = self.$orderSearchPopup.find('.btn-moreview');

            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataFailCheck(
           	    url,
           	    param,
           	    function (result) {
           	        var data = result.data,
           	            html;

           	        if(!!result.data.customer && data.customer.orders.items.length > 0){

           	            var pageInfo = data.customer.page_info; 
           	            if(pageInfo.current_page < pageInfo.total_pages){
           	                $morebtn.show();
           	            }else{
           	                $morebtn.hide();
           	            }
           	            
           	            data.customer.orders.items.forEach(function(item , index){
							if(item.order_date) {
								item.order_date = vcui.date.format(item.order_date, "yyyy-MM-dd")
							}
           	                item.items.forEach(function(itm , idx){
           	                    if(itm.product_sale_price) {
           	                        itm.product_sale_price.value = vcui.number.addComma(itm.product_sale_price.value);
           	                    }
           	                });
           	            });
           	            
           	            html = vcui.template(orderTmpl, data.customer.orders);

           	            if(pageInfo.current_page == 1){
           	                $orderList.html(html);
           	                $orderList.show();
           	            }else{
           	                $orderList.append(html);
           	            }
           	            
           	            self.param = {
           	                pagination: {                        				
           	                    "page": pageInfo.current_page,
           	                    "totalCount": pageInfo.total_pages,
           	                }
           	            } 
           	         	self.$orderSearchPopup.find('.no-data').hide();
           	        }else{
           	        	$morebtn.hide();
           	        	$orderList.html('').hide();
           	            self.$orderSearchPopup.find('.no-data').show();
           	        }

           	        lgkorUI.hideLoading();
           	    },//success
           	    function (err) {
       	            self.$orderSearchPopup.find('.no-data').html('<p>조회 실패했습니다.</p>').show();
           	        lgkorUI.hideLoading();
           	    }//fail
           	);

        },
        reset: function() {
            var self = this;

            self.param = {};

            self.$inquiryList.empty();
            self.$completeBtns.hide();
            self.$selectedModelBar.hide();
            self.$stepInput.find('#inquiryTitle').val('');
            self.$stepInput.find('#inquiryContent').val('');

            
            //BTOCSITE-2409 [긴급] 이메일문의 > 특정 문의 시 컬럼 추가
            $('#orderNo').hide();
            $('#orderNo').find('input').val('')
            $('#partNo').hide();
            $('#partNo').find('input').val('')
            $('#memberInfo').hide();
            $('#memberInfo').find('input').val('')
            

            self.$searchInput.vcInputClearButton('updateVal', '');
            
            if (!isLogin) {
                $('#userName').val('');
                $('#phoneNo').val('');
                self.$email.val('');
                self.$userEmailId.val('');

                $('#userEmailSelect select').vcSelectbox('value', '');
                self.setBSVal('bottomSheet-emailSelect', '');  // bottomsheet
            }

            $('#stepInputBtn1').prop('disabled', true);
            $('#stepInputBtn2').prop('disabled', true);  
            
            validation.reset();

            self.$cont.find('.ui_all_checkbox').vcCheckboxAllChecker('setAllNoneChecked');
            self.$cont.find('.ui_textcontrol').trigger('textcounter:change', { textLength: 0 });
            self.$cont.find('.ui_imageinput').vcImageMovFileInput('removeAll'); // BTOCSITE-14892 동영상 첨부 기능 추가
            
            $("#step1").addClass("active");
            $("#stepInquiryType").addClass("active"); 

            $("#stepInput").removeClass("active");
            $("#stepInput2").removeClass("active");  

            $(".wrap").removeClass("cs-service");
            lgkorUI.setBottomTabBarVisible(true);
        },
        validateStep1: function(){


        	var inquiryTitle = $('#stepInput').find('[name=inquiryTitle]').val();
        	var inquiryContent = $('#stepInput').find('[name=inquiryContent]').val();
        	
        	if(inquiryTitle!='' && inquiryContent!=''){
            	var result = validation.validate(["inquiryTitle", "inquiryContent"]);
            	
            	if (result.success) {
            		$('#stepInputBtn1').prop('disabled', false);
                }else{
                	$('#stepInputBtn1').prop('disabled', true);
            	}
            }else{
            	$('#stepInputBtn1').prop('disabled', true);
            }
        },
        validateStep2: function(){

        	var userName = $('#stepInput2').find('[name=userName]').val();
        	var phoneNo = $('#stepInput2').find('[name=phoneNo]').val();
        	var userEmailId = $('#stepInput2').find('[name=userEmailId]').val();
        	var privcyCheck = $('#stepInput2').find('[name=privcyCheck]:checked').val();

        	var isVal = lgkorUI.isLogin ? (userName!='' && phoneNo!='' && userEmailId!='') : (userName!='' && phoneNo!='' && userEmailId!='' && privcyCheck=='Y');
            if (isVal) {  
            	$('#stepInputBtn2').prop('disabled', false);
            	
            	var result;
            	if(isLogin){
            		result = validation.validate(["userName", "userEmailId", "phoneNo"]);	
            	}else{
            		result = validation.validate(["userName", "userEmailId", "phoneNo", "privcyCheck"]);
            	}
            	
            	if(result.success){
	            	$('#stepInputBtn2').prop('disabled', false);
            	}else{
            		$('#stepInputBtn2').prop('disabled', true);
            	}
            	
            }else{
            	$('#stepInputBtn2').prop('disabled', true);
            }
        },
        nextStep: function() {
            $("#stepInput").removeClass("active");
            $("#stepInput2").addClass("active");                       
            
            // BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
            if(isLogin){
                var result2 = validation.validate();

                if (result2.success) {  
                    $('#stepInputBtn2').prop('disabled', false);
                }else{
                    $('#stepInputBtn2').prop('disabled', true);
                }
            }
        },
        getLiveingDomain: function(){
            var referrer = window.location.hostname;
            var url = lgkorUI.parseUrl(referrer)

            if( url.hostname == lgkorUI.DOMAIN_LIST[0] ) {
                return 'https://living.lge.co.kr';
            }
            if( url.hostname == lgkorUI.DOMAIN_LIST[1]) {
                return 'https://living-stg.lge.co.kr';
            } 
            if ( url.hostname == lgkorUI.DOMAIN_LIST[2] || url.hostname == lgkorUI.DOMAIN_LIST[6]){
                return 'https://living-dev.lge.co.kr'
            }
        },
        bindEvent: function() {
            var self = this;

            // 모델 선택 & 문의 재선택
            self.$cont.on('complete', function(e, data) {
            	e.stopPropagation();
                self.param = $.extend(true, self.param, data);
                
                if (data.productCode || data.mktModelCd) {
                	self.loadInquiry();
                } else {
                    self.nextStepInput();
                }

                $('#step1').removeClass('active');
                $('#stepInquiryType').removeClass('active');

            }).on('reset', function() {

                //BTOCSITE-64468 고객지원 > 1:1 문의시 주문번호 및 상품번호 조회 기능 제공
				var cateNm = $('.prod-selected-wrap li:nth-child(2)').html();
				if( cateNm == '구매문의' || cateNm == '케어용품/소모품') {
					var now = new Date();	// 현재 날짜 및 시간
					var monthAgo = new Date(now);
					monthAgo.setMonth(now.getMonth() - 3);
		
		            self.$dateFilterStartDate = self.$termFilter.find('#date-input1');
		            self.$dateFilterEndDate = self.$termFilter.find('#date-input2');
		            
					self.$dateFilterStartDate.vcCalendar('setDate',  vcui.date.format(monthAgo , 'yyyyMMdd'));
					self.$dateFilterEndDate.vcCalendar('setDate', vcui.date.format(now , 'yyyyMMdd'));
					self.orderSearchInit();
				}

                self.reset();
            });

            //BTOCSITE-2409 [긴급] 이메일문의 > 특정 문의 시 컬럼 추가
            self.$stepInquiry.find('.desc-btn button[data-sub-category-name]').on('click', function(e){

                if(vcui.detect.isMobileDevice){
                    var url = location.pathname;
                    window.history.pushState({data: url}, '', url);
                }

            	e.preventDefault();
            	var $this = $(this);
                var data = $this.data();
                    data.categoryNm = data.categoryName;
                    data.subCategoryNm = data.subCategoryName;
                
                var isMenu = vcui.array.include(['이벤트','사이트 이용','멤버십','케어용품/소모품','LGE.COM 구매문의','베스트샵 매장 구매 문의','일반문의'], data.subCategoryNm);

                if (isMenu && !lgkorUI.isLogin) {
                    $('#loginEnterPopup').vcModal({ isHash: false });
                    return;
                }
                

                if(data.subCategoryNm == "멤버십"){
                    $('#membershipInfoPopup').vcModal({ isHash: false });
                    return;
                }
                if(data.subCategoryNm == "구독문의"){
                    $('#rentalInfoPopup').vcModal({ isHash: false });
                    return;
                }
                if (data.subCategoryNm == "케어용품/소모품" || data.subCategoryNm == "LGE.COM 구매문의") {
                    $('#orderNo').show();
                    $('#partNo').show();
                    self.orderSearchInit(); //BTOCSITE-64468 고객지원 > 1:1 문의시 주문번호 및 상품번호 조회 기능 제공
                }
                if(data.subCategoryNm == "LG전자 회원"){
                    $('#memberInfo').show();
                }

                $("html, body").scrollTop(0);
            });

      

            $('#membershipInfoPopup').find('.btn-group button:eq(1)').on('click', function(e) {
                e.preventDefault();
                $('#membershipInfoPopup').vcModal('hide');

                var param = {
                    category : 'ROOT',
                    categoryNm : '사이트 관련 문의',
                    subCategory : 'A003293',
                    subCategoryNm : '멤버십'
                }
   
                self.complete(param);
            });

            //제품 관련 문의
            self.$step1.find('.btn-next').on('click', function() {
                var $this = $(this);
            	var data = $(this).data();

 				if (!lgkorUI.isLogin && data.name == '홈스타일 문의') {
                    $('#loginEnterPopup').vcModal({ isHash: false });
                    return;
                } 

            	if(data.name == '홈스타일 문의'){
    				lgkorUI.alert('', {
    					title: "홈스타일 1:1 문의는 주문 내역 기준으로 <br>가능합니다. 주문 내역으로 이동합니다.",
    					okBtnName: '확인',
    					ok: function(){
    						location.href = '/my-page/order-status';
    					},
    				}, $this);
            	}

                if(data.name == '상담 예약/문의'){
                    location.href = '/support/request-call-reservation';
                }
            });

           

       	// 이메일 선택 시 셋팅 이벤트, (서충원, 230602)
            function selectValCheck(val) {
                if(val == "direct") {
                    self.$userEmailWrap.addClass('no-mark');
                }
                else {
                    self.$userEmailWrap.removeClass('no-mark');
                }
            }

                $(document).on('click', '#bottomSheet-emailSelect .bottom-sheet-selectbox li', function(e){
                	e.preventDefault();
                    var val = $(this).find('a').data('value');
                    selectValCheck(val);
                  	//이메일 도메인 선택시 직접인력 change 이벤트 발생
                    
                  	// BTOCSITE-51309 1:1 문의 & 이메일 문의] 휴대폰 번호 입력 항목 추가
    	            var userEmailId = $('#userEmailId').val();  

    	            if(val != "direct"){
    	            	self.$email.val(userEmailId + '@' + val);
    	            	$('#useEmailSelect select').val('value', val);
    	            }
    	            $('#emailSelect').vcSelectbox('update');
    	            
                    validation.validate(["userEmailId"]);
                    self.validateStep2();
                });
                $('#userEmailSelect select').on('change', function(){
                    var val = $(this).val();
                    selectValCheck(val);
                    //이메일 도메인 선택시 직접인력 change 이벤트 발생
                    
                    $('#bottomSheet-emailSelect a[data-value="'+val+'"]').parent().click();
                });

            
            $('#userEmailId').on('keyup',function(e,data){
                var val = $(this).val();
                val = vcui.string.replaceAll(val, ' ', '');
                $(this).val(val);
            });

            $('#userEmailId').on('keydown',function(e,data){
            	if(e.which === vcui.keyCode.SPACE){
                    $(this).val($(this).val().replace(/^\s+/,""));
                    return false;
                }
            });

			//추가 전달 내용
            //BTOCSITE-84932 (WAF 이슈 대응) 고객문의글에 개인정보 Pattern 인식 시, Alert 적용
            if(!vcui.detect.isMobileDevice){
                self.$textarea.on('focusout', function(){
                    var numbers = $(this).val().replace(/\D/g, "");
                    if(numbers.length >= 11){
                        lgkorUI.confirm('', {
                            typeClass: 'type2',
                            title: '<p>혹시 전달사항에 개인 정보(전화번호, 주소 등)가 포함되어 있나요?<br>한 번 더 체크해 주세요.</p>',
                            okBtnName: '개인 정보 없음',
                            cancelBtnName: '수정하기',
                            ok:function(){
                                setTimeout(function(){
                                    lgkorUI.scrollTo(self.$stepInput2);
                                    self.$stepInput2.focus();
                                }, 100);
                            },
                            cancel:function(){ 
                                setTimeout(function(){
                                    numbers = '';
                                    self.$textarea.focus();
                                }, 500);
                            },
                        });
                    }

                });
            }
            
			$('#userEmailId, #userEmailSelect select').on('change',function(e, data){// 이메일 변경 시
	            //이메일 userEmailId 조합
	            var userEmailId = $('#userEmailId').val();
	            var selectVal = $('#userEmailSelect option:selected').val();

                userEmailId = vcui.string.replaceAll(userEmailId, ' ', '');
                $('#userEmailId').val(userEmailId);
	            
	            if(selectVal == "direct"){
	            	self.$email.val(userEmailId);
	            }else{
	            	self.$email.val(userEmailId + '@' + selectVal);
	            }
	            validation.validate(["userEmailId"]);
			});  
			
	            $('#inquiryTitle, #inquiryContent').on('keyup', function () {

                    self.validateStep1();
	            });
	            $('#userName, #userEmailId, #phoneNo').on('keyup', function () {

                    self.validateStep2();
	            });
	            $('#privcyCheck').on('change', function () {	            	
	            	self.validateStep2();
	            }); 
            
			
            $(window).on('resize', function(){
                //BTOCSITE-71856 고객지원 > 고객의 소리 > Input Box 실시간 체크로 변경 요청
                if( window.innerWidth < 768 && !$(window).data('breakpoint').isMobile) {
                	var result = validation.validate();

                	if(result.success){
                		$('#stepInputBtn2').prop('disabled', false);
                	}else{
                		$('#stepInputBtn2').prop('disabled', true);
                	}
                }
            });
            // 모바일 bottom button
            self.$completeBottomBtns1.find('.btn-confirm').on('click', function() {
                var result = validation.validate(["inquiryTitle", "inquiryContent"]);
                if (result.success) {

                    var numbers = self.$textarea.val().replace(/\D/g, "");
                    if(numbers.length >= 11) {
                        lgkorUI.confirm('', {
                            typeClass: 'type2',
                            title: '<p>혹시 전달사항에 개인 정보(전화번호, 주소 등)가 포함되어 있나요?<br>한 번 더 체크해 주세요.</p>',
                            okBtnName: '개인 정보 없음',
                            cancelBtnName: '수정하기',
                            ok:function(){
                                setTimeout(function(){
                                    self.nextStep();
                                }, 100);
                            },
                            cancel:function(){ 
                                setTimeout(function(){
                                    self.$textarea.focus();
                                }, 500);
                            },
                        });
                    } else {
                        self.nextStep();
                    }
                }
            });

            self.$completeBottomBtns2.find('.btn-confirm').on('click', function() {
                var result = validation.validate();
                // BTOCSITE-72831 고객의 소리- 사이트 관련 문의 - LG전자 회원 본인인증 절차 추가 요청
                if (!authFlag && result.success) {

                    $('#authName').val($('#userName').val()).prop('readonly', true);
				    $('#authPhoneNo').val($('#phoneNo').val()).prop('readonly', true);                    
                    var $certificationPopup = $('#certificationPopup');
                    $certificationPopup.vcModal();
                }
                else if (authFlag && result.success) {    
                	//  BTOCSITE-45312 이메일 상담] ERMS 이슈 대응 건
                	var msg = "답변은 ‘예약 조회/변경’ 메뉴에서 확인하실 수 있습니다.  (단, 답변일로부터 1개월간 확인 가능)";
                    lgkorUI.confirm(msg, {
                        title: '문의 하시겠습니까?',
                        okBtnName: '확인',
                        cancelBtnName: '취소',
                        ok: function() {
                            self.requestComplete();
                        }
                    },$(this) || '');
                }
            });

            // 신청 완료
            self.$completeBtns.find('.btn-confirm').on('click', function() {
                var result = validation.validate();
                // BTOCSITE-72831 고객의 소리- 사이트 관련 문의 - LG전자 회원 본인인증 절차 추가 요청
                if (!authFlag && result.success) {

                    $('#authName').val($('#userName').val()).prop('readonly', true);
				    $('#authPhoneNo').val($('#phoneNo').val()).prop('readonly', true);                    
                    var $certificationPopup = $('#certificationPopup');
                    $certificationPopup.vcModal();
                }
                else if (authFlag && result.success) {    
                //  BTOCSITE-45312 이메일 상담] ERMS 이슈 대응 건
                	var msg = "답변은 ‘예약 조회/변경’ 메뉴에서 확인하실 수 있습니다.  (단, 답변일로부터 1개월간 확인 가능)";
                	lgkorUI.confirm(msg, {
                        title:'문의 하시겠습니까?',
                        okBtnName: '확인',
                        cancelBtnName: '취소',
                        ok: function() {
                            self.requestComplete();
                        }
                	},$(this) || '');
                }
            });

            $(document).on('click', '.btn_ui_outlink', function(){
                var $this= $(this);
                var $popup = $this.closest('article.lay-wrap');

                $popup.vcModal('hide');
            });
            //BTOCSITE-8855 s
            $(document).on('click', '.faq-link a', function(e){
                if(isApp()) {
                    e.preventDefault();
                    var appUrl = $(this).attr('href');
                    if (!(appUrl.match('https://'))) {
                        appUrl = 'https://'+window.LGEAPPHostName+appUrl;
                    } 
                    if(vcui.detect.isIOS){
                        var jsonString = JSON.stringify({'url': appUrl, 'command':'sendOutLink'});
                        webkit.messageHandlers.callbackHandler.postMessage(jsonString);
                    } else {
                        android.openLinkOut(appUrl);
                    }
                } 
            })
            //BTOCSITE-8855 e
            
            // BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
            var $imgView = $('.btn-img-view');
            $('#select2').on('change', function(){
    
                // 이미지가 없는 경우 no-img 삭제
                if (lgkorUI.NO_IMAGE_MODEL_NAME == $imgView.find('img').attr('src')) {
                    $imgView.find('img').removeClass('no-img');
                }
            });

            // BTOCSITE-66105 1:1문의 ESG 카테고리 이메일 링크 연결
            // BTOCSITE-66791 [즉시적용] 투자자정보 사이트에 컨택 정보 게시 요청
			$('.lay-wrap').on('click', 'button , a', function(e){
				var url = location.pathname;
        		window.history.pushState({data: url}, '', url);
			});

            // BTOCSITE-13601 모델명 확인 방법 > 이미지 확대 추가
            $imgView.on('click', function(e) {
                e.preventDefault();
            
                if($(this).find('img').hasClass('no-img')) return;
    
                var domain=location.origin;
                var imgUrl=domain + $(this).attr('href');
                var imgAlt = $(this).find('img').attr('alt');
                if(!vcui.detect.isMobileDevice){
                    window.open(imgUrl, '', '');
                    return
                }

                var currOption = $('#select2 option:selected');
                var popTitle = currOption.hasClass('placeholder') ? '모델명 확인 방법' : currOption.text();
                var $zoomPopup = $('#imgZoomPopup');
                var $zoomImg = $('#imgZoomPopup img');
                $zoomImg.attr('src', imgUrl);
                $zoomImg.attr('alt', imgAlt);

                $zoomPopup.find('.tit').html('<span>'+popTitle+'</span>');
                $zoomPopup.vcModal('open');
            });
            
            //BTOCSITE-65169 [모니터링 G][APP] 팝업창의 [아니오]버튼 Tap 후 [1:1 문의] 화면에 머물지 않고 자동으로 홈페이지로 이동하는 현상
			$('#recruitPopup').on('click', '.ui_modal_close', function(e){
				var url = location.pathname;
        		window.history.pushState({data: url}, '', url);
			});
            
            // BTOCSITE-72831 고객의 소리- 사이트 관련 문의 - LG전자 회원 본인인증 절차 추가 요청
			$('#certificationPopup').on('click', '.ui_modal_close', function(e){
				var url = location.pathname;
        		window.history.pushState({data: url}, '', url);
			});
            
            //BTOCSITE-64468 고객지원 > 1:1 문의시 주문번호 및 상품번호 조회 기능 제공
            $('#orderNo').on('click', '.btn-order-search', function(e){
            	$('#orderSearchPopup').vcModal({isHash:false, opener:$(this)});
            });

            $('#inquiryPartNo').on('input', function(e){
            	var $this = $(this),
                    value = $this.val().toUpperCase();
                    $this.val(value);
            });
            //주문번호 팝업 - 기간 조회
            self.$orderSearchPopup.find('.term-filter .btn-calendarInquiry').on('click', function(e){

                var dateData = self.$termFilter.vcDatePeriodFilter("getSelectOption");                
                var startDate =vcui.date.format(dateData.startDate, "yyyy-MM-dd");
                var endDate = vcui.date.format(dateData.endDate, "yyyy-MM-dd");
            	var param = {
                        "pageSize": 10,
            			"currentPage": 1,
            			"filters_from": startDate,
            			"filters_to": endDate,
            	}

				var monthDiff = vcui.date.monthDiff(startDate, endDate);

				if(monthDiff > 6) {
                    lgkorUI.alert("", {
						title: '최대 6개월 단위로 조회 가능합니다.'
					});
				}else{
	            	self.requestCustomerOrder(param);
					var $btn = self.$orderSearchPopup.find('.btn-selected');
					$btn.prop('disabled', true);
				}

            });
            
            //주문번호 팝업 - 라디오 선택
            self.$orderSearchPopup.on('change', 'input[name=rdo_prod]', function(e){

            	var $btn = self.$orderSearchPopup.find('.btn-selected');
            	$btn.prop('disabled', false);
            });
            //주문번호 팝업 - 선택완료
            self.$orderSearchPopup.on('click', '.btn-selected', function(e){

            	var value = self.$orderSearchPopup.find('input[name=rdo_prod]:checked').val();
				if(!!value){
	            	$('#inquiryOrderNo').val(value);
	            	self.$orderSearchPopup.vcModal('hide');
				}
            });
			//주문번호 팝업 - 더보기
            self.$orderSearchPopup.on('click', '.btn-moreview', function(e) {
				
                var dateData = self.$termFilter.vcDatePeriodFilter("getSelectOption");                
                var startDate =vcui.date.format(dateData.startDate, "yyyy-MM-dd");
                var endDate = vcui.date.format(dateData.endDate, "yyyy-MM-dd");

            	var param = {
                        "pageSize": 10,
            			"currentPage": self.param.pagination.page + 1,
            			"filters_from": startDate,
            			"filters_to": endDate,
            	}

            	self.requestCustomerOrder(param);
            });
			
            if(vcui.detect.isMobileDevice){
                window.addEventListener("popstate", function(evt) {

                    var activeId = $('.step-box.active').attr('id');
                    if(activeId == 'step1'){
                        window.historyBack();
                    }else{
                        var url = location.pathname;
                        window.history.pushState({data: url}, '', url);
                        $('.prod-selected-wrap').find('button').trigger('click');
                    }
                    
                }, false);
            }

            // BTOCSITE-72831 고객의 소리- 사이트 관련 문의 - LG전자 회원 본인인증 절차 추가 요청
            self.$authPopup.on('modalhide', function() {
                var $this = $(this);

                self.$authPopup.find('.btn-send').text('인증 번호 발송');
                $this.find('#authNo').prop('disabled', true);
                $this.find('input').val('');
            });

            // 인증문자 보내기
            self.$authPopup.find('.btn-send').on('click', function() {
                // authManager.send(this);
            	//BTOCSITE-52418 휴대 전화번호 인증 절차시, 휴대폰 번호 재확인 절차 검토
                var _this = this;
                var phoneNo = $('#authPhoneNo').val();
                    phoneNo = phoneNo.replace(/^(02|\d{3})(\d{3,4})(\d{4})$/, "$1-$2-$3");
                var title = '휴대전화 번호를 확인해주세요! <br> 입력하신 <em class="color-3">'+ phoneNo +'</em>로 <br>인증 번호를 발송하시겠습니까?';
                
                lgkorUI.confirm(title, {
                    typeClass:'type2',
                    title:'',
                    okBtnName: '네',
                    cancelBtnName: '아니요',
                    ok: function() {
                    	authManager.send(_this);
                    },
                    cancel: function() {}
                }, _this);

            });

            // 인증 완료하기
            self.$authPopup.find('.btn-auth').on('click', function() {
                authManager.confirm('.btn-open', function(success, result) {
                    authFlag = success;
                });
				var url = location.pathname;
        		window.history.pushState({data: url}, '', url);
            });

            // BTOCSITE-119103 : 고객지원 내 AI Chat 진입점 s
            self.$cont.find("#inquiryChatbot").on('click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation(); 

                var aiAssistantData = {
                        "state": "customer_support_email",
                        "layer": {
                            "click_id": "btn_simpleinquiry"
                        }
                    };
                var url = "/ai-commerce/aiAssistant";
                
                // 기존 openAiAssistance 함수와 동일한 팝업 규격 설정
                var popupWidth = 450;
                var popupHeight = 1500;
                var browserLeft = window.screenX || window.screenLeft || 0;
                var browserWidth = window.outerWidth || window.screen.width;
                var leftPosition = browserLeft + browserWidth - popupWidth;
                var topPosition = window.screenY || window.screenTop || 0;
                
                // 팝업 실행
                var aiPopup = window.open(url, "aiAssistant", "height=" + popupHeight + ",width=" + popupWidth + ",left=" + leftPosition + ",top=" + topPosition);
                
                if (aiPopup) {
                    setTimeout(function() {
                        aiPopup.aiAssistantData = aiAssistantData;
                    }, 200); 
                }
            });
            //BTOCSITE-119103 : 고객지원 내 AI Chat 진입점 e
        }
    }

    $(window).ready(function() {
        var emailReg = /[\?&]emailReg([^&#]*)/.exec(window.location.href);
        if(emailReg){
            setTimeout(function () {
                $('#stepInquiryType .btn-next').trigger('click');
            }, 100);
        };
        
        reservation.init();
    });
})();